/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/

export const RoutesSections = [
  {
    path:'/',
    label:'Inicio',
    slug: 'dashboard',
  },
  {
    path:'/licencias',
    label:'Licencias',
    slug: 'licenses',
  },
  {
    path:'/empresas',
    label:'Empresas',
    slug: 'companies',
  },
  {
    path:'/usuarios',
    label:'Usuarios',
    slug: 'users',
  },
  {
    path:'/invitaciones',
    label:'Invitaciones',
    slug: 'invitations',
  },
  {
    path:'/roles',
    label:'Roles y permisos',
    slug: 'roles',
  },
  {
    path:'/help',
    label:'Ayuda',
    slug: 'help',
    icon: '',
  },
];

export const TableData = {
  pageSize: 10,
};

export const TableDataLocale = {
  emptyText: 'No se encontraron resultados.',
};